import {AngularAppLogger} from "../angular-app-logger";

export class PatientImportData
{
  patientData: any;
  oktaToken: string | null;
  apiURL: string | null;
  epicAuthToken: string | null;
  issURL: string | null;
  appLogger: AngularAppLogger;
}
